module.exports = __webpack_public_path__ + "static/media/tom-ford-tobacco-vanille-big.b1c97d98.png";